<div>
    <div class="row">
        <div class="col-sm-5">
            <p class="dataFecha" style="margin: 20px;">NIVELES DE ATENCIÓN POR TRAMO ETARIO</p>
        </div>
        <div class="col-sm-2">
            <p class="dataFecha" style="margin: 20px;">NÚMERO DE SALAS</p>
        </div>
        <div class="col-sm-2">
            <p class="dataFecha" style="margin: 20px;">EDAD DE LOS PARVULOS</p>
        </div>
        <div class="col-sm-3">
            <p class="dataFecha" style="margin: 20px;">OBSERVACIÓN</p>
        </div>
    </div>

    <div class="row">
        <div class="col-sm-5">
            <p class="titulo" style="margin: 20px;">SALA CUNA MENOR</p>
        </div>
        <div class="col-sm-2">
            <input type="number" value="{{estructuraNiveles.numSalasSCMenor}}" [(ngModel)]="estructuraNiveles.numSalasSCMenor" [disabled]="readonly">
        </div>
        <div class="col-sm-2">
            <input type="number" value="{{estructuraNiveles.edadSCMenor}}" [(ngModel)]="estructuraNiveles.edadSCMenor" [disabled]="readonly">
        </div>
        <div class="col-sm-3">
            <textarea class="text-area-observacion-nivel" name="observacionSCMenor" [(ngModel)]="estructuraNiveles.observacionSCMenor" [disabled]="readonly" ></textarea>
        </div>
    </div>

    <div class="row">
        <div class="col-sm-5">
            <p class="titulo" style="margin: 20px;">SALA CUNA MAYOR</p>
        </div>
        <div class="col-sm-2">
            <input type="number" value="{{estructuraNiveles.numSalasSCMayor}}" [(ngModel)]="estructuraNiveles.numSalasSCMayor" [disabled]="readonly">
        </div>
        <div class="col-sm-2">
            <input type="number" value="{{estructuraNiveles.edadSCMayor}}" [(ngModel)]="estructuraNiveles.edadSCMayor" [disabled]="readonly">
        </div>
        <div class="col-sm-3">
            <textarea class="text-area-observacion-nivel" name="observacionSCMayor" [(ngModel)]="estructuraNiveles.observacionSCMayor" [disabled]="readonly" ></textarea>
        </div>
    </div>

    <div class="row">
        <div class="col-sm-5">
            <p class="titulo" style="margin: 20px;">SALA CUNA HETEROGÉNEA</p>
        </div>
        <div class="col-sm-2">
            <input type="number" value="{{estructuraNiveles.numSalasSCHG}}" [(ngModel)]="estructuraNiveles.numSalasSCHG" [disabled]="readonly">
        </div>
        <div class="col-sm-2">
            <input type="number" value="{{estructuraNiveles.edadSCHG}}" [(ngModel)]="estructuraNiveles.edadSCHG" [disabled]="readonly">
        </div>
        <div class="col-sm-3">
            <textarea class="text-area-observacion-nivel" name="observacionSCHG" [(ngModel)]="estructuraNiveles.observacionSCHG" [disabled]="readonly" ></textarea>
        </div>
    </div>

    <div class="row">
        <div class="col-sm-5">
            <p class="titulo" style="margin: 20px;">NIVEL MEDIO MENOR</p>
        </div>
        <div class="col-sm-2">
            <input type="number" value="{{estructuraNiveles.numSalasMMenor}}" [(ngModel)]="estructuraNiveles.numSalasMMenor" [disabled]="readonly">
        </div>
        <div class="col-sm-2">
            <input type="number" value="{{estructuraNiveles.edadMMenor}}" [(ngModel)]="estructuraNiveles.edadMMenor" [disabled]="readonly">
        </div>
        <div class="col-sm-3">
            <textarea class="text-area-observacion-nivel" name="observacionMMenor" [(ngModel)]="estructuraNiveles.observacionMMenor" [disabled]="readonly" ></textarea>
        </div>
    </div>

    <div class="row">
        <div class="col-sm-5">
            <p class="titulo" style="margin: 20px;">NIVEL MEDIO MAYOR</p>
        </div>
        <div class="col-sm-2">
            <input type="number" value="{{estructuraNiveles.numSalasMMayor}}" [(ngModel)]="estructuraNiveles.numSalasMMayor" [disabled]="readonly">
        </div>
        <div class="col-sm-2">
            <input type="number" value="{{estructuraNiveles.edadMMayor}}" [(ngModel)]="estructuraNiveles.edadMMayor" [disabled]="readonly">
        </div>
        <div class="col-sm-3">
            <textarea class="text-area-observacion-nivel" name="observacionMMayor" [(ngModel)]="estructuraNiveles.observacionMMayor" [disabled]="readonly" ></textarea>
        </div>
    </div>

    <div class="row">
        <div class="col-sm-5">
            <p class="titulo" style="margin: 20px;">GRUPO HETEROGÉNEO (NIVELES MEDIOS)</p>
        </div>
        <div class="col-sm-2">
            <input type="number" value="{{estructuraNiveles.numSalasMHG}}" [(ngModel)]="estructuraNiveles.numSalasMHG" [disabled]="readonly">
        </div>
        <div class="col-sm-2">
            <input type="number" value="{{estructuraNiveles.edadMHG}}" [(ngModel)]="estructuraNiveles.edadMHG" [disabled]="readonly">
        </div>
        <div class="col-sm-3">
            <textarea class="text-area-observacion-nivel" name="observacionMHG" [(ngModel)]="estructuraNiveles.observacionMHG" [disabled]="readonly" ></textarea>
        </div>
    </div>

    <div class="row">
        <div class="col-sm-5">
            <p class="titulo" style="margin: 20px;">PRIMER NIVEL TRANSICIÓN</p>
        </div>
        <div class="col-sm-2">
            <input type="number" value="{{estructuraNiveles.numSalasPNT}}" [(ngModel)]="estructuraNiveles.numSalasPNT" [disabled]="readonly">
        </div>
        <div class="col-sm-2">
            <input type="number" value="{{estructuraNiveles.edadPNT}}" [(ngModel)]="estructuraNiveles.edadPNT" [disabled]="readonly">
        </div>
        <div class="col-sm-3">
            <textarea class="text-area-observacion-nivel" name="observacionPNT" [(ngModel)]="estructuraNiveles.observacionPNT" [disabled]="readonly" ></textarea>
        </div>
    </div>

    <div class="row">
        <div class="col-sm-5">
            <p class="titulo" style="margin: 20px;">SEGUNDO NIVEL TRANSICIÓN</p>
        </div>
        <div class="col-sm-2">
            <input type="number" value="{{estructuraNiveles.numSalasSNT}}" [(ngModel)]="estructuraNiveles.numSalasSNT" [disabled]="readonly">
        </div>
        <div class="col-sm-2">
            <input type="number" value="{{estructuraNiveles.edadSNT}}" [(ngModel)]="estructuraNiveles.edadSNT" [disabled]="readonly">
        </div>
        <div class="col-sm-3">
            <textarea class="text-area-observacion-nivel" name="observacionSNT" [(ngModel)]="estructuraNiveles.observacionSNT" [disabled]="readonly" ></textarea>
        </div>
    </div>

    <div class="row">
        <div class="col-sm-5">
            <p class="titulo" style="margin: 20px;">GRUPO HETEROGÉNEO (NIVELES TRANSICIÓN)</p>
        </div>
        <div class="col-sm-2">
            <input type="number" value="{{estructuraNiveles.numSalasTHG}}" [(ngModel)]="estructuraNiveles.numSalasTHG" [disabled]="readonly">
        </div>
        <div class="col-sm-2">
            <input type="number" value="{{estructuraNiveles.edadTHG}}" [(ngModel)]="estructuraNiveles.edadTHG" [disabled]="readonly">
        </div>
        <div class="col-sm-3">
            <textarea class="text-area-observacion-nivel" name="observacionTHG" [(ngModel)]="estructuraNiveles.observacionTHG" [disabled]="readonly" ></textarea>
        </div>
    </div>

    <div class="row">
        <div class="col-sm-5">
            <p class="titulo" style="margin: 20px;">GRUPO HETEROGÉNEO (NIVEL MEDIO/TRANSICIÓN)</p>
        </div>
        <div class="col-sm-2">
            <input type="number" value="{{estructuraNiveles.numSalasMTHG}}" [(ngModel)]="estructuraNiveles.numSalasMTHG" [disabled]="readonly">
        </div>
        <div class="col-sm-2">
            <input type="number" value="{{estructuraNiveles.edadMTHG}}" [(ngModel)]="estructuraNiveles.edadMTHG" [disabled]="readonly">
        </div>
        <div class="col-sm-3">
            <textarea class="text-area-observacion-nivel" name="observacionMTHG" [(ngModel)]="estructuraNiveles.observacionMTHG" [disabled]="readonly" ></textarea>
        </div>
    </div>


</div>
